import { ESharedFunction } from "motw_core/Enums/ESharedFunction";
import { SetState } from "source/app/services/UI/State/SetState";


export function StopStopWatch() {
    SetState<Date | null>(
        ESharedFunction.DisplayStopWatch_startDateTime,
        null,
        false // don't merge states when using dates
    );
}
